import { Empty, Typography } from 'antd';
import { t } from 'i18next';
import { CommunicationAdvancedSearch } from '../advanced-search/CommunicationAdvancedSearch.tsx';
import { CommunicationItem } from '../CommunicationItem.tsx';
import { type CommunicationListProps } from '../CommunicationList.tsx';

interface ICommunicationItemsListProps extends CommunicationListProps {
  communications: NonNullable<CommunicationListProps['communications']>;
}

/**
 * Componente centralizzato della lista delle comunicazioni in stile "standard"
 * come elenco (in contrapposizione alla vista a tabella).
 */
export function CommunicationItemsList(props: ICommunicationItemsListProps) {
  const { query, defaultQuery, setQuery, communications, isBackoffice } = props;

  return (
    <>
      <CommunicationAdvancedSearch
        query={query}
        defaultQuery={defaultQuery}
        setQuery={setQuery}
        total={props.total}
        isBackoffice={isBackoffice}
      />
      {communications.map(communication => (
        <CommunicationItem
          key={communication.id}
          communication={communication}
          isBackoffice={isBackoffice}
        />
      ))}

      {communications.length === 0 && (
        <Empty
          description={
            <Typography.Text>
              {t(
                'communication-list.no-comms-to-show',
                'Non ci sono comunicazioni da mostrare',
              )}
            </Typography.Text>
          }
        />
      )}
    </>
  );
}
